import { LucideIconName } from 'components/LucideIcon'
import { RolodexEntryType } from 'types'
import { z } from 'zod'

export type OntologyField = string

export type OntologyRolodexEntryType = RolodexEntryType | string

export const ontologyFieldTypeSchema = z.enum([
  'text',
  'number',
  'enum',
  'boolean',
  'date',
  'object',
  'array',
])

export const ontologyFieldDefinitionSchema = z.object({
  name: z.string(),
  type: ontologyFieldTypeSchema,
  allowedValues: z.array(z.string()).optional(),
  description: z.string().optional(),
})

export const ontologyTypeDefinitionSchema = z.object({
  displayName: z.string(),
  pluralName: z.string(),
  icon: z.string() as z.ZodType<LucideIconName>,
  color: z.string(),
  titleProperty: z.string(),
  requiredTags: z.array(z.string()),
  fields: z.record(z.string(), ontologyFieldDefinitionSchema),
})

export const ontologyV2Schema = z.object({
  types: z.record(z.string(), ontologyTypeDefinitionSchema),
})

export type OntologyFieldType = z.infer<typeof ontologyFieldTypeSchema>

export type OntologyFieldDefinition = z.infer<
  typeof ontologyFieldDefinitionSchema
>

export type OntologyTypeDefinition = z.infer<
  typeof ontologyTypeDefinitionSchema
>

export type OntologyV2 = z.infer<typeof ontologyV2Schema>

// Extended types that add additional properties beyond the base schema
export interface EnrichedOntologyFieldDefinition extends OntologyFieldDefinition {
  entryType: OntologyRolodexEntryType
  key: string
  keyOrField: 'key' | 'field'
}

// TODO why does this live in the ontology - can we move this into the Explorer table component?
// https://app.asana.com/1/957917091101853/project/1209606087561609/task/1211435751461704
export interface TableSchemaColumnDef {
  copyField?: OntologyFieldDefinition
  columnTitle?: string
  tagColor?: string
  linkTemplate?: string
  name: string
}
